/**
 * Sparten für Versorgungstarife und Verbrauchszähler (Objekt-Check, Kap. 7).
 *
 * Dasselbe Vokabular wie `UTILITY_KINDS` in `backend/src/routes/utilities.ts` –
 * an einer Stelle gepflegt, damit Tarif- und Zähler-Formular nicht auseinanderlaufen.
 */
export const UTILITY_KINDS = ['electricity', 'water', 'gas', 'district_heat', 'oil', 'pellets'] as const;
export type UtilityKind = (typeof UTILITY_KINDS)[number];

export const UTILITY_KIND_LABELS: Record<UtilityKind, string> = {
  electricity: 'Strom',
  water: 'Wasser',
  gas: 'Gas',
  district_heat: 'Fernwärme',
  oil: 'Öl',
  pellets: 'Pellets',
};

/** Zählerarten tragen eine eigene Bezeichnung – „Stromzähler“ statt „Strom“. */
export const METER_KIND_LABELS: Record<UtilityKind, string> = {
  electricity: 'Stromzähler',
  water: 'Wasserzähler',
  gas: 'Gaszähler',
  district_heat: 'Fernwärme',
  oil: 'Öl',
  pellets: 'Pellets',
};

/** Öl und Pellets tragen eine Kapazität (Liter/kg), die übrigen eine Zählernummer. */
export const METER_KIND_USES_CAPACITY: Record<UtilityKind, boolean> = {
  electricity: false,
  water: false,
  gas: false,
  district_heat: false,
  oil: true,
  pellets: true,
};

export const METER_CAPACITY_UNIT: Record<UtilityKind, string> = {
  electricity: '',
  water: '',
  gas: '',
  district_heat: '',
  oil: 'Liter',
  pellets: 'kg',
};
